import type { ComponentProps } from 'react';
import { makeStyles } from '@material-ui/styles';

import LabeledRadio from '../../../LabeledRadio/LabeledRadio';
import { type Mode } from '../../types/Mode';

const useStyles = makeStyles({
  radioRoot: {
    marginRight: '8px',
    padding: '6px 0',
  },
  formControlLabelRoot: {
    margin: '0',
  },
});

type TagSelectLabeledRadioProps = {
  value: Mode;
  label: string;
} & Partial<ComponentProps<typeof LabeledRadio>>;

const TagSelectLabeledRadio = ({
  value,
  label,
  ...labeledRadioProps
}: TagSelectLabeledRadioProps) => {
  const classes = useStyles();

  return (
    <LabeledRadio
      {...labeledRadioProps}
      classes={{
        root: classes.radioRoot,
      }}
      value={value}
      label={label}
      FormControlLabelProps={{
        classes: {
          root: classes.formControlLabelRoot,
        },
        onClick: e => {
          e.preventDefault();

          e.currentTarget
            .querySelector<HTMLInputElement>('input[type="radio"]')
            ?.click();
        },
      }}
    />
  );
};

export default TagSelectLabeledRadio;
